<template>
  <button class="button" :class="'--' + theme" @click="$emit('click')"><slot></slot></button>
</template>
<script>
export default {
  name: 'Button',
  props: {
    theme: {
      type: String,
      default: 'violet',
    },
  },
}
</script>
<style lang="scss">
button.button {
  width: 100%;
  height: 46px;
  line-height: 46px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  border-radius: 23px;
  background: #731982;
  font-size: 17px;
  font-weight: 500;
  &.--green {
    background: #04b358;
  }
  &.--white {
    background: #fff;
    color: #000;
  }
}
</style>
